module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/tee/4-8aa431348ed12dd917c48255d093e98c.jpg";